import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchClientProcedureAvailableCourseById } from 'app/actions/CourseActions';
import { getCourseClientProcedureAvailable } from 'app/reducers';
import isEmpty from 'app/utils/IsEmpty';

export default function CourseClientProcedureAvailableContainer(props){
    let courseClientProcedureAvailable = useSelector(getCourseClientProcedureAvailable)
    const dispatch = useDispatch();
    
    useEffect(() => {
        if (isEmpty(courseClientProcedureAvailable)) fetchCourseClientProcedureAvailableAction();
    }, []);

    const fetchCourseClientProcedureAvailableAction = () => dispatch(fetchClientProcedureAvailableCourseById(props.id));
    courseClientProcedureAvailable.map(item => item['key'] = item.idProcedure);
    courseClientProcedureAvailable.map(item => item['disabled'] = false);
    return (props.children({ courseClientProcedureAvailable}));
}